export default "__VITE_ASSET__B0hbhyn7__"